export default {
  "--color-primary": "rgb(155, 8, 79)",
  "--color-primary-active": "rgb(193, 11, 99)",
  "--color-secondary-active": "rgb(255, 248, 122)",
  "--color-secondary-inverse": "rgb(0, 17, 35)",
  "--color-tertiary": "rgb(227, 97, 100)",
  "--text-color-link": "rgb(155, 8, 79)",
  "--text-color-link-active": "rgb(193, 11, 99)",
  "--text-color-primary": "rgb(155, 8, 79)",
  "--text-color-secondary-inverse": "rgb(0, 17, 35)",
  "--background-color-primary": "rgb(155, 8, 79)",
  "--background-color-primary-active": "rgb(193, 11, 99)",
  "--background-color-secondary-active": "rgb(255, 248, 122)",
  "--background-color-secondary-inverse": "rgb(0, 17, 35)",
  "--border-color-active": "rgb(155, 8, 79)",
  "--border-color-primary": "rgb(155, 8, 79)"
};